import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content"]
  static values = { type: String }

  connect() {
    this.activateTab(this.tabTargets[0])
    this.showTabContent(this.tabTargets[0].dataset.tabId)
  }

  changeTab(event) {
    event.preventDefault()

    this.tabTargets.forEach(tab => {
      this.deactivateTab(tab)
    })

    this.activateTab(event.currentTarget)
    this.showTabContent(event.currentTarget.dataset.tabId)
  }

  activateTab(tab) {
    const link = tab.querySelector('a')
    const activeClass = link.dataset.activeClass
    const inactiveClass = link.dataset.inactiveClass

    tab.classList.add('active')

    if (activeClass && inactiveClass) {
      link.className = activeClass
    }
  }
  deactivateTab(tab) {
    const link = tab.querySelector('a')
    const activeClass = link.dataset.activeClass
    const inactiveClass = link.dataset.inactiveClass

    tab.classList.remove('active')

    if (activeClass && inactiveClass) {
      link.className = inactiveClass
    }
  }

  showTabContent(tabId) {
    this.contentTargets.forEach((content) => {
      if (content.dataset.tabId === tabId) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })
  }
}
